import Vue from "vue";
import ApiService from "../common/api.service";
import {
  TOGGLE_SHOW_FILTERS,

  ACTIVE_COMP,
  SELECT_PHOTO_ADD,
  SELECT_PHOTO_REMOVE,
  SELECT_ALL_PHOTO_ADD,
  SELECT_ALL_PHOTO_REMOVE,
  TOGGLE_SHOW_SELECTED,
  SELECTED_RESET,

  PHOTO_SEARCH,
  PHOTO_SEARCH_RESET,
  PHOTO_UPDATE_RESULT_ITEM,
  PHOTO_UPDATE_PUBLISH_STATE,
  NEW_SEARCH_IDENTIFIER,
} from "./actions.type";
import {
  SET_SHOW_FILTERS,

  SET_ACTIVE_COMP,
  SET_ALL_SELECT_PHOTO_ADD,
  SET_ALL_SELECT_PHOTO_REMOVE,
  SET_SELECT_PHOTO_REMOVE,
  SET_SELECT_PHOTO_ADD,
  SET_SHOW_SELECTED,

  SET_PHOTO_SEARCH_RESULT,
  RESET_SEARCH,
  SET_LOADING_STATE,
  SET_SEARCH_QUERY,
  SET_PHOTO_RESULT_ITEM,
  SET_PHOTO_RESULT_SET_PUBLISH_STATE,
  SET_SEARCH_IDENTIFIER,
  RESET_STATE_PHOTO_ITEM
} from "./mutations.type";

const initialState = {
  showFiltersMobile: false,
  imageSearchResult: { data: [] },
  resultPage: 1,
  searchQueryStore: {},
  queryParams: {},
  loadingState: 'false',

  selectAllLimit: 2500,
  selectedImages: [],
  showSelected: false,
  activeComponent: null,
  searchIdentifier: null,
};

export const state = {
  ...initialState
};

export const actions = {
  [NEW_SEARCH_IDENTIFIER](context) {
    const ident = String(Date.now()) + String(Math.random() * 9999)
    context.commit(SET_SEARCH_IDENTIFIER, ident);
    console.log('NEW_SEARCH_IDENTIFIER', ident)
  },
  [TOGGLE_SHOW_FILTERS](context) {
    console.log(state.showFiltersMobile);
    state.showFiltersMobile = !state.showFiltersMobile
    context.commit(SET_SHOW_FILTERS, state.showFiltersMobile);
  },
  // Selecting
  [ACTIVE_COMP](context, compName) {
    context.commit(SET_ACTIVE_COMP, compName);
  },
  [SELECTED_RESET](context) {
    context.commit(RESET_STATE_PHOTO_ITEM, 'selectedImages');
  },
  [TOGGLE_SHOW_SELECTED](context) {
    state.showSelected = !state.showSelected
    context.commit(SET_SHOW_SELECTED, state.showSelected);
  },

  async [SELECT_ALL_PHOTO_ADD](context, payload) {
    let queryParams = {}

    queryParams = state.searchQueryStore
    queryParams.ids_only = true
    queryParams.page = 1
    queryParams.per_page = state.selectAllLimit

    console.log(state.queryParams, 'STATE');
    const {
      data
    } = await ApiService.query("photos", {
      params: queryParams
    });
    return context.commit(SET_ALL_SELECT_PHOTO_ADD, { photos: data.data })
  },

  [SELECT_ALL_PHOTO_REMOVE](context, payload) {
    context.commit(SET_ALL_SELECT_PHOTO_REMOVE, payload);
  },

  [SELECT_PHOTO_ADD](context, payload) {
    context.commit(SET_SELECT_PHOTO_ADD, payload);
  },
  [SELECT_PHOTO_REMOVE](context, payload) {
    context.commit(SET_SELECT_PHOTO_REMOVE, payload);
  },

  // Searching
  async [PHOTO_SEARCH](context, searchParams = null) {
    context.commit(SET_LOADING_STATE, true);

    // const ident = String(Date.now()) + String(Math.random() * 9999)
    // context.commit(SET_SEARCH_IDENTIFIER, ident);

    let queryParams = {}

    if (searchParams === null) {
      queryParams = state.searchQueryStore
      queryParams.per_page = 25
      queryParams.ids_only = false
      queryParams.page = state.resultPage
    }
    else {
      queryParams = searchParams
      queryParams.per_page = 25
      queryParams.ids_only = false
      context.commit(SET_SEARCH_QUERY, searchParams)
    }

    const {
      data
    } = await ApiService.query("photos", {
      params:queryParams
    });

    state.resultPage += 1
    console.log(data);
    if (state.resultPage > data.last_page) {
      state.resultPage = 1
      data.complete = true
    }
    context.commit(SET_LOADING_STATE, false);
    context.commit(SET_PHOTO_SEARCH_RESULT, data);
    return data;
  },


  [PHOTO_SEARCH_RESET]({ commit }) {
    commit(RESET_SEARCH);
  },

  [PHOTO_UPDATE_PUBLISH_STATE](context, payload) {
    payload.ids.forEach(pid => {
      state.imageSearchResult.data.find((photo, i) => {
        if (photo.id == pid) {
          console.log(i);
          context.commit(SET_PHOTO_RESULT_SET_PUBLISH_STATE, { index: i, pubState: payload.publishChoice});
        }
      });
    });
  }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
export const mutations = {
  [SET_SHOW_FILTERS](state, show) {
    console.log(show);
    state.showFiltersMobile = show;
  },

  [SET_ACTIVE_COMP](state, compName) {
    state.activeComponent = compName;
  },

  [SET_SHOW_SELECTED](state, show) {
    state.showSelected = show;
  },

  [SET_ALL_SELECT_PHOTO_ADD](state, payload) {
    this.state.photoSearch.imageSearchResult.data = this.state.photoSearch.imageSearchResult.data.map(function (el) {
      var o = Object.assign({}, el);
      o.selected = true;
      return o;
    })

    state.selectedImages = payload.photos
  },
  [SET_ALL_SELECT_PHOTO_REMOVE](state, payload) {

    this.state.photoSearch.imageSearchResult.data = this.state.photoSearch.imageSearchResult.data.map(function (el) {
      var o = Object.assign({}, el);
      o.selected = false;
      return o;
    })

    state.selectedImages = [];
  },


  [SET_SELECT_PHOTO_ADD](state, payload) {

    let photo = payload.photo
    photo.selected = true

    state.imageSearchResult.data[payload.index] = photo

    state.selectedImages = state.selectedImages.concat([payload.photo]);
  },
  [SET_SELECT_PHOTO_REMOVE](state, payload) {
    this.state.photoSearch.imageSearchResult.data[payload.index].selected = false
    state.selectedImages = state.selectedImages.filter(t => t.id !== payload.photo.id);
  },

  [SET_PHOTO_RESULT_ITEM](state, payload) {
    state.imageSearchResult.data[payload.index] = photo
  },

  [SET_PHOTO_RESULT_SET_PUBLISH_STATE](state, payload) {
    console.log(payload);
    console.log(state.imageSearchResult.data[payload.index], 'result');
    state.imageSearchResult.data[payload.index].published_to_client = payload.pubState
  },


  [SET_LOADING_STATE](state, loadingState) {
    state.loadingState = loadingState
  },

  [SET_SEARCH_IDENTIFIER](state, ident) {
    state.searchIdentifier = ident
    console.log('SET_SEARCH_IDENTIFIER', state, ident)
  },

  [NEW_SEARCH_IDENTIFIER](state) {
    const ident = String(Date.now()) + String(Math.random() * 9999)
    state.searchIdentifier = ident
    console.log('NEW_SEARCH_IDENTIFIER', state, ident)
  },

  [SET_SEARCH_QUERY](state, previouseSearchQuery) {
    state.searchQueryStore = previouseSearchQuery
  },
  [SET_PHOTO_SEARCH_RESULT](state, photos) {
    console.log(photos, 'image reasults');
    if (state.imageSearchResult.data.length > 0) {
      state.imageSearchResult.current_page = photos.current_page
      state.imageSearchResult.data = state.imageSearchResult.data.concat(photos.data);
    } else {
      state.imageSearchResult = photos
    }
  },

  [RESET_STATE_PHOTO_ITEM](state, item) {
    state[item] = initialState[item]
  },
  [RESET_SEARCH](state) {
    for (let f in state) {
      Vue.set(state, f, initialState[f]);
    }
  },
};

const getters = {
  imageSearchResult(state) {
    return state.imageSearchResult;
  },

  selectedImages(state) {
    return state.selectedImages;
  },
  selectedImagesIds(state) {
    return state.selectedImages.map((val, index, arr) => {
      return val.id;
    });
  },
  // imageSearchResult(state) {
  //   return state.imageSearchResult;
  // },
  showSelected(state) {
    return state.showSelected;
  },
  showFilters(state) {
    return state.showFiltersMobile;
  }

};

export default {
  state,
  actions,
  mutations,
  getters
};
